var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.me.profile == 'Master')?_c('list-component',{ref:"list_component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }